var exports = {
  "Z": "xa15a2ab7--dc3258--layout",
  "Q": "xa15a2ab7--dc3258--text",
};

module.exports = exports;
